// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_SortArray from "../../../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as PorterStoreIcons from "./PorterStoreIcons.bs.js";
import * as PorterStoreToast from "./PorterStoreToast.bs.js";
import * as PorterStoreTypes from "../PorterStoreTypes.bs.js";
import * as PorterStoreButton from "./PorterStoreButton.bs.js";
import * as PorterStoreStrings from "../PorterStoreStrings.bs.js";
import * as PorterStoreItemCard from "./PorterStoreItemCard.bs.js";
import * as PorterStoreFormField from "./PorterStoreFormField.bs.js";
import * as PorterStoreToastHook from "./PorterStoreToastHook.bs.js";
import * as PorterStoreStatusBadge from "./PorterStoreStatusBadge.bs.js";

function PorterStoreOrderSidebar(Props) {
  var orderDetail = Props.orderDetail;
  var onClose = Props.onClose;
  var isCompletedOpt = Props.isCompleted;
  var allProductsOpt = Props.allProducts;
  var onSave = Props.onSave;
  var onSendPaymentLink = Props.onSendPaymentLink;
  var isCompleted = isCompletedOpt !== undefined ? isCompletedOpt : false;
  var allProducts = allProductsOpt !== undefined ? allProductsOpt : [];
  var order = orderDetail.order;
  var match = PorterStoreToastHook.useToast(3000, undefined);
  var showFailure = match[2];
  var showSuccess = match[1];
  var toastState = match[0];
  var initialStatus = order.orderStatus;
  var match$1 = React.useState(function () {
        return initialStatus;
      });
  var setCurrentStatus = match$1[1];
  var currentStatus = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowStatusDropdown = match$2[1];
  var match$3 = React.useState(function () {
        if (orderDetail.addressLine1 !== "" && order.city !== "") {
          return orderDetail.pincode !== "";
        } else {
          return false;
        }
      });
  var setIsSaved = match$3[1];
  var partnerName = order.partnerName;
  var phoneNumber = order.phoneNumber;
  var partnerId = orderDetail.partnerId;
  var initialAddress_addressLine1 = orderDetail.addressLine1;
  var initialAddress_addressLine2 = orderDetail.addressLine2;
  var initialAddress_city = order.city;
  var initialAddress_state = orderDetail.state;
  var initialAddress_pincode = orderDetail.pincode;
  var initialAddress = {
    addressLine1: initialAddress_addressLine1,
    addressLine2: initialAddress_addressLine2,
    city: initialAddress_city,
    state: initialAddress_state,
    pincode: initialAddress_pincode
  };
  var match$4 = React.useState(function () {
        return initialAddress;
      });
  var setAddress = match$4[1];
  var address = match$4[0];
  var initialItems = orderDetail.items;
  var match$5 = React.useState(function () {
        return initialItems;
      });
  var setOrderedItems = match$5[1];
  var orderedItems = match$5[0];
  var match$6 = React.useState(function () {
        return allProducts;
      });
  var setAvailableProducts = match$6[1];
  var orderedProductCodes = Belt_Array.map(orderedItems, (function (i) {
          return i.productCode;
        }));
  var availableItems = Belt_Array.keep(match$6[0], (function (product) {
          return !Belt_Array.some(orderedProductCodes, (function (code) {
                        return code === product.productCode;
                      }));
        }));
  React.useEffect((function () {
          Curry._1(setOrderedItems, (function (param) {
                  return orderDetail.items;
                }));
          
        }), [orderDetail.items]);
  React.useEffect((function () {
          Curry._1(setAvailableProducts, (function (param) {
                  return allProducts;
                }));
          
        }), [allProducts]);
  var itemCount = orderedItems.length;
  var orderTotal = Belt_Array.reduce(orderedItems, 0, (function (acc, item) {
          return acc + item.price | 0;
        }));
  var isFormValid = partnerName !== "" && phoneNumber !== "" && partnerId !== "" && address.addressLine1 !== "" && address.city !== "" && address.state !== "" && address.pincode !== "";
  var buildPayload = function (crmStatus) {
    var addressChanged = address.addressLine1 !== initialAddress_addressLine1 || address.addressLine2 !== initialAddress_addressLine2 || address.city !== initialAddress_city || address.state !== initialAddress_state || address.pincode !== initialAddress_pincode;
    var currentSkus = Belt_SortArray.stableSortBy(Belt_Array.map(orderedItems, (function (i) {
                return i.sku;
              })), Caml.caml_string_compare);
    var initialSkus = Belt_SortArray.stableSortBy(Belt_Array.map(initialItems, (function (i) {
                return i.sku;
              })), Caml.caml_string_compare);
    var itemsChanged = currentSkus.length !== initialSkus.length || Belt_Array.some(currentSkus, (function (sku) {
            return !Belt_Array.some(initialSkus, (function (s) {
                          return s === sku;
                        }));
          }));
    var statusChanged = currentStatus !== initialStatus;
    return {
            address: addressChanged ? ({
                  receiver_name: partnerName,
                  receiver_phone: phoneNumber,
                  address_line_1: address.addressLine1,
                  address_line_2: address.addressLine2,
                  city: address.city,
                  state: address.state,
                  postal_code: address.pincode
                }) : undefined,
            items: itemsChanged ? Belt_Array.map(orderedItems, (function (item) {
                      return {
                              sku: item.sku,
                              quantity: 1
                            };
                    })) : undefined,
            crm_status: statusChanged ? crmStatus : undefined
          };
  };
  var noop = function (param) {
    
  };
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "ps-sidebar__header"
                }, React.createElement("div", {
                      className: "ps-sidebar__header-left"
                    }, React.createElement("span", {
                          className: "ps-sidebar__order-id"
                        }, order.orderNumber), React.createElement("span", {
                          className: "ps-order-details__date"
                        }, PorterStoreStrings.createdOnPrefix + PorterStoreTypes.formatDate(order.createdOn))), React.createElement("button", {
                      className: "ps-sidebar__close",
                      onClick: (function (param) {
                          return Curry._1(onClose, undefined);
                        })
                    }, React.createElement(PorterStoreIcons.Close.make, {})), React.createElement("div", {
                      className: "ps-sidebar__status-wrapper"
                    }, React.createElement("div", {
                          className: "ps-sidebar__status-pill",
                          onClick: (function (param) {
                              if (!isCompleted) {
                                return Curry._1(setShowStatusDropdown, (function (prev) {
                                              return !prev;
                                            }));
                              }
                              
                            })
                        }, React.createElement("span", {
                              className: "ps-sidebar__status-label"
                            }, PorterStoreStrings.statusLabel), isCompleted ? React.createElement("span", {
                                className: "ps-sidebar__complete-badge"
                              }, PorterStoreStrings.statusConfirmed) : React.createElement(React.Fragment, undefined, React.createElement(PorterStoreStatusBadge.make, {
                                    status: currentStatus
                                  }), React.createElement(PorterStoreIcons.StatusChevron.make, {}))), match$2[0] ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                                className: "ps-status-dropdown__overlay",
                                onClick: (function (param) {
                                    return Curry._1(setShowStatusDropdown, (function (param) {
                                                  return false;
                                                }));
                                  })
                              }), React.createElement("div", {
                                className: "ps-status-dropdown"
                              }, React.createElement("span", {
                                    className: "ps-status-dropdown__title"
                                  }, PorterStoreStrings.markStatusAs), React.createElement("div", {
                                    className: "ps-status-dropdown__list"
                                  }, Belt_Array.mapWithIndex(PorterStoreTypes.statusOptions, (function (index, status) {
                                          var isSelected = status === currentStatus;
                                          var statusStr = PorterStoreTypes.orderStatusToString(status);
                                          return React.createElement(React.Fragment, {
                                                      children: null,
                                                      key: statusStr
                                                    }, index > 0 ? React.createElement("div", {
                                                            className: "ps-status-dropdown__divider"
                                                          }) : null, React.createElement("div", {
                                                          className: "ps-status-dropdown__row",
                                                          onClick: (function (param) {
                                                              Curry._1(setCurrentStatus, (function (param) {
                                                                      return status;
                                                                    }));
                                                              Curry._1(setShowStatusDropdown, (function (param) {
                                                                      return false;
                                                                    }));
                                                              return Curry._1(setIsSaved, (function (param) {
                                                                            return false;
                                                                          }));
                                                            })
                                                        }, React.createElement("span", {
                                                              className: isSelected ? "ps-status-dropdown__label ps-status-dropdown__label--active" : "ps-status-dropdown__label"
                                                            }, statusStr), isSelected ? React.createElement(PorterStoreIcons.StatusCheck.make, {}) : null));
                                        }))))) : null)), React.createElement("div", {
                  className: "ps-sidebar__updated-bar"
                }, React.createElement("span", {
                      className: "ps-sidebar__updated-text"
                    }, PorterStoreStrings.lastUpdatedByPrefix, React.createElement("strong", undefined, orderDetail.lastUpdatedBy), PorterStoreStrings.lastUpdatedAtSeparator, React.createElement("strong", undefined, PorterStoreTypes.formatDate(orderDetail.lastUpdatedAt)))), React.createElement("div", {
                  className: "ps-sidebar__body"
                }, React.createElement("div", {
                      className: "ps-sidebar__section"
                    }, React.createElement("span", {
                          className: "ps-sidebar__section-title"
                        }, PorterStoreStrings.sectionDriverDetails), React.createElement("div", {
                          className: "ps-sidebar__form-row"
                        }, React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelPartnerName,
                              value: partnerName,
                              onChange: noop,
                              required: true,
                              disabled: true
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelPhoneNumber,
                              value: phoneNumber,
                              onChange: noop,
                              required: true,
                              disabled: true
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelPartnerId,
                              value: partnerId,
                              onChange: noop,
                              required: true,
                              disabled: true
                            }))), React.createElement("div", {
                      className: "ps-sidebar__section"
                    }, React.createElement("span", {
                          className: "ps-sidebar__section-title"
                        }, PorterStoreStrings.sectionAddressDetails), React.createElement("div", {
                          className: "ps-sidebar__form-grid"
                        }, React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelAddressLine1,
                              value: address.addressLine1,
                              onChange: isCompleted ? noop : (function (v) {
                                    Curry._1(setAddress, (function (prev) {
                                            return {
                                                    addressLine1: v,
                                                    addressLine2: prev.addressLine2,
                                                    city: prev.city,
                                                    state: prev.state,
                                                    pincode: prev.pincode
                                                  };
                                          }));
                                    return Curry._1(setIsSaved, (function (param) {
                                                  return false;
                                                }));
                                  }),
                              required: true,
                              disabled: isCompleted
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelAddressLine2,
                              value: address.addressLine2,
                              onChange: isCompleted ? noop : (function (v) {
                                    Curry._1(setAddress, (function (prev) {
                                            return {
                                                    addressLine1: prev.addressLine1,
                                                    addressLine2: v,
                                                    city: prev.city,
                                                    state: prev.state,
                                                    pincode: prev.pincode
                                                  };
                                          }));
                                    return Curry._1(setIsSaved, (function (param) {
                                                  return false;
                                                }));
                                  }),
                              disabled: isCompleted
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelCity,
                              value: address.city,
                              onChange: isCompleted ? noop : (function (v) {
                                    Curry._1(setAddress, (function (prev) {
                                            return {
                                                    addressLine1: prev.addressLine1,
                                                    addressLine2: prev.addressLine2,
                                                    city: v,
                                                    state: prev.state,
                                                    pincode: prev.pincode
                                                  };
                                          }));
                                    return Curry._1(setIsSaved, (function (param) {
                                                  return false;
                                                }));
                                  }),
                              required: true,
                              disabled: isCompleted
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelState,
                              value: address.state,
                              onChange: isCompleted ? noop : (function (v) {
                                    Curry._1(setAddress, (function (prev) {
                                            return {
                                                    addressLine1: prev.addressLine1,
                                                    addressLine2: prev.addressLine2,
                                                    city: prev.city,
                                                    state: v,
                                                    pincode: prev.pincode
                                                  };
                                          }));
                                    return Curry._1(setIsSaved, (function (param) {
                                                  return false;
                                                }));
                                  }),
                              required: true,
                              disabled: isCompleted
                            }), React.createElement(PorterStoreFormField.make, {
                              label: PorterStoreStrings.labelPincode,
                              value: address.pincode,
                              onChange: isCompleted ? noop : (function (v) {
                                    Curry._1(setAddress, (function (prev) {
                                            return {
                                                    addressLine1: prev.addressLine1,
                                                    addressLine2: prev.addressLine2,
                                                    city: prev.city,
                                                    state: prev.state,
                                                    pincode: v
                                                  };
                                          }));
                                    return Curry._1(setIsSaved, (function (param) {
                                                  return false;
                                                }));
                                  }),
                              required: true,
                              disabled: isCompleted
                            }))), React.createElement("div", {
                      className: "ps-sidebar__items-card"
                    }, React.createElement("div", {
                          className: "ps-sidebar__items-inner"
                        }, React.createElement("span", {
                              className: "ps-sidebar__section-title"
                            }, PorterStoreStrings.itemsOrderedPrefix + String(itemCount) + ")"), React.createElement("div", {
                              className: "ps-sidebar__items-list"
                            }, Belt_Array.map(orderedItems, (function (item) {
                                    if (isCompleted || item.hasValidation) {
                                      return React.createElement(PorterStoreItemCard.make, {
                                                  item: item,
                                                  key: item.id
                                                });
                                    } else {
                                      return React.createElement(PorterStoreItemCard.make, {
                                                  item: item,
                                                  onAction: (function (param) {
                                                      var itemId = item.id;
                                                      Curry._1(setOrderedItems, (function (prev) {
                                                              return Belt_Array.keep(prev, (function (i) {
                                                                            return i.id !== itemId;
                                                                          }));
                                                            }));
                                                      return Curry._1(setIsSaved, (function (param) {
                                                                    return false;
                                                                  }));
                                                    }),
                                                  action: /* Remove */0,
                                                  onSizeChange: (function (newSize) {
                                                      var itemId = item.id;
                                                      Curry._1(setOrderedItems, (function (prev) {
                                                              return PorterStoreTypes.updateItemSize(prev, itemId, newSize);
                                                            }));
                                                      return Curry._1(setIsSaved, (function (param) {
                                                                    return false;
                                                                  }));
                                                    }),
                                                  key: item.id
                                                });
                                    }
                                  })))), React.createElement("div", {
                          className: "ps-sidebar__total"
                        }, React.createElement("span", {
                              className: "ps-sidebar__total-label"
                            }, PorterStoreStrings.orderTotalLabel), React.createElement("span", {
                              className: "ps-sidebar__total-amount"
                            }, PorterStoreStrings.rupeeSymbol + String(orderTotal)))), !isCompleted && availableItems.length !== 0 ? React.createElement("div", {
                        className: "ps-sidebar__section"
                      }, React.createElement("span", {
                            className: "ps-sidebar__section-title"
                          }, PorterStoreStrings.sectionAddMoreItems), React.createElement("div", {
                            className: "ps-sidebar__add-items-row"
                          }, Belt_Array.map(availableItems, (function (item) {
                                  return React.createElement(PorterStoreItemCard.make, {
                                              item: item,
                                              onAction: (function (param) {
                                                  var itemId = item.id;
                                                  var i = Belt_Array.getBy(availableItems, (function (i) {
                                                          return i.id === itemId;
                                                        }));
                                                  if (i !== undefined) {
                                                    Curry._1(setOrderedItems, (function (prev) {
                                                            return Belt_Array.concat(prev, [i]);
                                                          }));
                                                    return Curry._1(setIsSaved, (function (param) {
                                                                  return false;
                                                                }));
                                                  }
                                                  
                                                }),
                                              action: /* Add */1,
                                              onSizeChange: (function (newSize) {
                                                  var itemId = item.id;
                                                  return Curry._1(setAvailableProducts, (function (prev) {
                                                                return PorterStoreTypes.updateItemSize(prev, itemId, newSize);
                                                              }));
                                                }),
                                              key: item.id
                                            });
                                })))) : null), isCompleted ? null : React.createElement("div", {
                    className: "ps-sidebar__footer"
                  }, React.createElement(PorterStoreButton.make, {
                        label: PorterStoreStrings.btnSave,
                        onClick: (function (param) {
                            var payload = buildPayload(PorterStoreTypes.orderStatusToApiString(currentStatus));
                            if (onSave !== undefined) {
                              return Curry._3(onSave, payload, (function (param) {
                                            Curry._1(setIsSaved, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(showSuccess, PorterStoreStrings.toastSaveSuccess);
                                          }), (function (param) {
                                            return Curry._1(showFailure, PorterStoreStrings.toastSaveFailure);
                                          }));
                            }
                            
                          }),
                        disabled: !(isFormValid || currentStatus !== initialStatus),
                        className: "ps-sidebar__save-btn"
                      }), React.createElement(PorterStoreButton.make, {
                        label: PorterStoreStrings.btnSendPaymentLink,
                        onClick: (function (param) {
                            var payload = buildPayload(PorterStoreTypes.orderStatusToApiString(currentStatus));
                            if (onSendPaymentLink !== undefined) {
                              return Curry._3(onSendPaymentLink, payload, (function (param) {
                                            return Curry._1(showSuccess, PorterStoreStrings.toastPaymentSuccess);
                                          }), (function (param) {
                                            return Curry._1(showFailure, PorterStoreStrings.toastPaymentFailure);
                                          }));
                            }
                            
                          }),
                        disabled: !(isFormValid && match$3[0])
                      })), React.createElement(PorterStoreToast.make, {
                  toastType: toastState.toastType,
                  message: toastState.message,
                  visible: toastState.visible
                }));
}

var make = PorterStoreOrderSidebar;

export {
  make ,
  
}
/* react Not a pure module */
